let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gz08i")).then(() => parcelRequire('5UqdW'));